import { Pipe, PipeTransform, inject } from '@angular/core';

import { DateTimeHelper } from '@pages/office/shared/helpers/date-time.helper';
import { UtilityService } from '@core/services/utility.service';
import { OfficeFieldWebInputType, OfficeFieldWebInputTypeEnum } from '@pages/office/models/office-data.model';

@Pipe({
  name: 'dateFromJson',
  standalone: true,
})
export class DateFromJsonPipe implements PipeTransform {
  private dateLookupTypes: string[] = [OfficeFieldWebInputTypeEnum.date, OfficeFieldWebInputTypeEnum.month];
  private utilityService = inject(UtilityService);

  transform(value: string, webInputType: OfficeFieldWebInputType, mask?: string): unknown {
    return this.dateLookupTypes.includes(webInputType)
      ? DateTimeHelper.formatDateByInputType(value, webInputType, mask, this.utilityService.getDateFormat())
      : value;
  }
}
